// Central RBAC map. Keep in sync with backend router role gates.
// role "admin" always has access to everything (short-circuited by hasRole).

// Routes that ONLY admins may open. Everything else is available to both
// admins and employees (Dashboard, POS, WE/WA/UL, Bestand, Produkte read,
// Buchungshistorie). Lagerorte is Stammdatenverwaltung → admin-only.
export const ADMIN_ONLY_ROUTES = new Set([
  "/kunden",
  "/lieferanten",
  "/automaten",
  "/integrationen",
  "/benutzer",
  "/kassen",
  "/archiv",
  "/lagerorte",
  "/kundenportal",
]);

// Produkte-Mutations (create/edit/archive/hard-delete) sind admin-only.
// Read (Liste + Detail) bleibt für Mitarbeiter erlaubt.
export const ADMIN_ONLY_ACTIONS = new Set([
  "product.create",
  "product.edit",
  "product.archive",
  "product.hard_delete",
  "location.mutate",
  "terminal.mutate",
  "supplier.mutate",
  "customer.mutate",
  "portal_cms.mutate",
]);

export function canDo(user, action) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return !ADMIN_ONLY_ACTIONS.has(action);
}

export function hasRole(user, requiredRoles) {
  if (!user || !user.role) return false;
  if (user.role === "admin") return true;
  if (!requiredRoles || requiredRoles.length === 0) return true;
  return requiredRoles.includes(user.role);
}

export function canOpenRoute(user, path) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return !ADMIN_ONLY_ROUTES.has(path);
}
